import { UserCheck, ClipboardCheck, PackageCheck, Building2 } from "lucide-react";

export const MODULE_TYPES = [
  {
    key: "USER_REGISTRATION",
    label: "User Registration",
    description: "Approve new employee and client sign-ups before they can log in",
    icon: UserCheck,
    iconWrap: "bg-info_bg text-info border-info_border",
    accent: "bg-info",
    glow: "bg-info",
  },
  {
    key: "PROJECT_REVIEW",
    label: "Project Review Sign-off",
    description: "Approve work moving from review to done across active projects",
    icon: ClipboardCheck,
    iconWrap: "bg-primary_tint text-primary border-primary_tint",
    accent: "bg-primary",
    glow: "bg-primary",
  },
  {
    key: "PROJECT_COMPLETION",
    label: "Project Completion",
    description: "Approve final delivery and handover of completed projects",
    icon: PackageCheck,
    iconWrap: "bg-success_bg text-success border-success_border",
    accent: "bg-success",
    glow: "bg-success",
  },
  {
    key: "COMPANY_ONBOARDING",
    label: "Client Onboarding",
    description: "Approve new company and client accounts before activation",
    icon: Building2,
    iconWrap: "bg-warning_bg text-warning border-warning_border",
    accent: "bg-warning",
    glow: "bg-warning",
  },
];
